@use '../../scss/utility';

:host {
  display: block;
  margin-block-end: var(--wb-spacing-xxs);
  color: var(--wb-grey-45);

  @include utility.breakpoint-from(mq5) {
    margin-block-end: utility.wb-pixel-to-rem(16px);
  }
}

:host(:last-child) {
  margin-block-end: 0;
}

.anchor {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: utility.wb-pixel-to-rem(48px);
  color: inherit;
  text-decoration: none;
  cursor: pointer;

  &:focus-visible {
    outline: utility.wb-pixel-to-rem(1px) solid var(--wb-blue-45);
    outline-offset: utility.wb-pixel-to-rem(5px);
  }

  &:hover {
    color: var(--wb-black);

    ::slotted(.wb-icon) {
      color: var(--wb-black);
    }
  }

  @include utility.breakpoint-from(mq5) {
    height: initial;
  }
}

::slotted(.wb-icon) {
  margin-inline-end: var(--wb-spacing-xs);
  color: inherit;
}
